import type { SvgProps } from 'react-native-svg';

/**
 * Icon Component Props
 *
 * All icon components accept these props for consistent sizing and coloring.
 */
export interface IconProps extends Omit<SvgProps, 'width' | 'height'> {
  /**
   * Icon size in pixels
   * @default 16
   */
  size?: number;

  /**
   * Icon color
   * Supports any valid color string (hex, rgb, named colors, etc.)
   * @default '#020202'
   */
  color?: string;

  /**
   * Accessible label for screen readers
   */
  accessibilityLabel?: string;
}
